import { Injectable, computed, inject, signal } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { globalConfig } from '../utils/globalConfig';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GuardService {
  private http = inject(HttpClient);
  route = inject(Router);

  #stateUsuarioData = signal<any>({
    nombreCompleto: String,
    perfilUsuario: {},
  });

  #statePermisosCache = signal<any>({
    permisos: [],
  });

  public usuarioData = computed(() => this.#stateUsuarioData());
  public permisos = computed(() => this.#statePermisosCache().permisos);

  constructor() {}

  authenticated(): Observable<object> {
    return this.http.get('/auth/validate-token');
  }

  async getPermisosCache(): Promise<any> {
    try {
      //se consultan los permisos
      const { data }: any = await lastValueFrom(this.http.get('/auth/get-permisos-cache'));
      // se encriptan los permisos y se guardan en localStorage
      //sessionStorage.setItem(globalConfig.permisosUsuario, data?.encrypted);
      this.#statePermisosCache.set({
        permisos: data?.decrypted,
      });
      //se retornan los permisos
      return this.#statePermisosCache().permisos;
    } catch (error) {
      this.logout();
    }
  }

  resetPermisos() {
    //se borran los permisos
    this.#statePermisosCache.set({
      permisos: [],
    });
  }

  setToken(token: string) {
    sessionStorage.setItem(globalConfig.tokenApi, token);
  }

  setUserData(perfilUsuario: any, usuario: any) {
    this.#stateUsuarioData.set({
      id: usuario.id,
      nombreCompleto: `${usuario.nombres} ${usuario.apellidos}`,
      primerInicio: usuario.primerInicio,
      identificacion: usuario.identificacion,
      perfilUsuario: perfilUsuario.nombre,
      perfilUsuarioId: perfilUsuario.id,
      nivelPerfil: perfilUsuario.nivelPerfil,
    });
  }

  logout() {
    sessionStorage.removeItem(globalConfig.tokenApi);
    sessionStorage.removeItem(globalConfig.permisosUsuario);
    this.resetPermisos();
    this.route.navigate(['/auth/sign-in']);
  }

  getPerfilUsuario() {
    return this.#stateUsuarioData()?.nivelPerfil;
  }
}
